// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { list, get } from "./operations.js";
export type {
  DeletedAccountsListOptionalParams,
  DeletedAccountsGetOptionalParams,
} from "./options.js";
